var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_vm._v(" "+_vm._s(_vm.$store.getters['question/optionsCategory'])+" "),_c('FormView',{attrs:{"data":_vm.$store.getters['question/detailData'],"fields":_vm.$store.getters['question/tableFields']},on:{"load":_vm.loadData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }